// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-f6a32630]{position:absolute;top:0;left:0;right:0;bottom:0;z-index:4;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);width:100%;margin:0 auto;border-radius:15px}", ""]);
// Exports
module.exports = exports;
